import { Message } from './message.model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<Message> {
  isLoaded: boolean
  isLoading: boolean
  isAddingMessage: boolean
  unreadCount: number
  isUnreadCountLoaded: boolean
  isUnreadCountLoading: boolean
}

export const adapter: EntityAdapter<Message> = createEntityAdapter<Message>({
  sortComparer: (m1, m2) => m2.created - m1.created,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  isAddingMessage: false,
  unreadCount: 0,
  isUnreadCountLoaded: false,
  isUnreadCountLoading: false,
})
